import * as Yup from "yup";
import { RiMapPinFill } from "react-icons/ri";
import { IoMdMailUnread } from "react-icons/io";
import { MdOutlinePhoneAndroid } from "react-icons/md";

export const validationSchema = Yup.object({
  full_name: Yup.string()
    .transform((value) => (value ? value.trim() : ""))
    .required("Full name is required")
    .test("min-chars", "Name must be at least 2 characters", (value) => {
      if (!value) return false;
      const clean = value.replace(/[.\s]/g, "");
      return clean.length >= 2;
    }),
  email_address: Yup.string().trim().required("Email is required").max(254, "Email address is too long").email("Please enter a valid email address"),
  phone_number: Yup.string()
    .required("Phone number is required")
    .matches(/^[0-9]+$/, "Phone number must contain only digits (0-9)")
    .min(10, "Phone number must be at least 10 digits")
    .max(15, "Phone number cannot exceed 15 digits")
    .test("is-valid-phone", "Please enter a valid phone number", (value) => {
      if (!value) return false;
      // Basic international phone validation (allows most real numbers)
      return /^\+?[0-9]{8,15}$/.test(value) || /^[0-9]{8,15}$/.test(value);
    }),
  services: Yup.string().required("Please select a service"),
  message: Yup.string()
    .transform((value) => (value ? value.trim() : ""))
    .required("Project details are required")
    .test("min-chars", "Message must be at least 10 characters", (value) => {
      if (!value) return false;
      const clean = value.replace(/[.\s]/g, "");
      return clean.length >= 10;
    }),
});

export const services = [
  { value: "", label: "Select a service" },
  { value: "app", label: "App Development" },
  { value: "web", label: "Web Development" },
  { value: "cloud", label: "Cloud & DevOps" },
  { value: "marketing", label: "Digital Marketing" },
  { value: "aiConsultation", label: "AI Consultation" },
  { value: "other", label: "Other" },
];

export const contactItems = [
  {
    img: "/images/contact/emaillogo.webp",
    label: "Email us",
    value: "contact@tychotechnologies.com",
    sub: "We reply within 24 hours",
    color: "var(--c-brand)",
    type: "email",
    href: "mailto:contact@tychotechnologies.com",
  },
  {
    img: "/images/contact/callus.webp",
    label: "Call us",
    value: "+91 9205671059",
    sub: "Mon–Fri, 9 AM – 7 PM IST",
    color: "var(--c-accent)",
    type: "phone",
    href: "tel:+919205671059",
  },
  {
    img: "/images/contact/visitus.webp",
    label: "Visit us",
    value: "Office No. 305, 3rd Floor, H-32, Sector-63, Noida, Uttar Pradesh, India - 201301.",
    color: "var(--c-lime)",
    type: "location",
    href: "https://www.google.com/maps/place/Tycho+Technologies+%7C+Mobile+Apps,+OTT,+ROKU+%26+Web+Development+Company+in+India/@28.6297619,77.3766279,17z/data=!3m1!4b1!4m14!1m7!3m6!1s0x390ce40a1a48d491:0x773396a1d869a95f!2sTycho+Technologies+%7C+Mobile+Apps,+OTT,+ROKU+%26+Web+Development+Company+in+India!8m2!3d28.6297572!4d77.3792028!16s%2Fg%2F11g889jrhd!3m5!1s0x390ce40a1a48d491:0x773396a1d869a95f!8m2!3d28.6297572!4d77.3792028!16s%2Fg%2F11g889jrhd?entry=ttu&g_ep=EgoyMDI2MDQwOC4wIKXMDSoASAFQAw%3D%3D",
  },
];
